// 组件对象，大写
import goodsSelect from './goodsSelect.vue'
export default goodsSelect
